import { createApp } from 'vue';
import RafToAvifConverter from '../Components/RafToAvifConverter.vue';

const root = document.getElementById('raf-to-avif-converter');
if (root) {
  createApp(RafToAvifConverter).mount('#raf-to-avif-converter');
}
